import { RotaCheckbox } from "@teamrota/rota-design";
import React, { useState } from "react";

import CurrencyInput from "~/src/components/form-field/inputs/currency-input";
import { Cell, Row } from "./style";

const RoleList = ({
  roles,
  isEditing,
  memberRoles,
  isShowPayRateColumn,
  isShowPayTypeColumn,
  setUpdatedMemberRoles
}) => {
  const [selectedRoles, setSelectedRoles] = useState(memberRoles);

  const onToggleRole = ({ id: roleId, name, defaultPayRate, isDayRate }) => {
    const isChecked = selectedRoles.find(
      selectedRole => selectedRole.roleId === roleId
    );

    if (isChecked) {
      const updatedRoles = selectedRoles.filter(
        selectedRole => selectedRole.roleId !== roleId
      );
      setSelectedRoles(updatedRoles);
      setUpdatedMemberRoles(updatedRoles);
    } else {
      const updatedRoles = [
        ...(selectedRoles || []),
        {
          roleId,
          name,
          payRateOverride: defaultPayRate,
          isDayRate
        }
      ];
      setSelectedRoles(updatedRoles);
      setUpdatedMemberRoles(updatedRoles);
    }
  };

  const onChangeMemberRoleRate = ({ payRateOverride, roleId }) => {
    const updatedRoles = selectedRoles.map(role => {
      if (role.roleId === roleId) {
        return { ...role, payRateOverride };
      }
      return role;
    });
    setSelectedRoles(updatedRoles);
    setUpdatedMemberRoles(updatedRoles);
  };

  return (
    <>
      {roles.map(role => {
        const matchingSelectedRole = selectedRoles.find(
          selectedRole => selectedRole.roleId === role.id
        );

        return (
          <Row key={role.id}>
            <Cell alignLeft>
              {isEditing ? (
                <RotaCheckbox
                  label={role.name}
                  isChecked={!!matchingSelectedRole}
                  onClick={() => onToggleRole(role)}
                />
              ) : (
                role.name
              )}
            </Cell>
            {isShowPayTypeColumn && (
              <Cell>{role.isDayRate ? "Daily" : "Hourly"}</Cell>
            )}
            {isShowPayRateColumn && (
              <Cell center width="120px">
                <CurrencyInput
                  hasNoErrorText
                  isAlignCenter
                  input={{
                    value: role?.payRateOverride || role?.defaultPayRate,
                    onChange: payRateOverride =>
                      onChangeMemberRoleRate({
                        payRateOverride,
                        roleId: role.id
                      })
                  }}
                  meta={{}}
                  readOnly={!isEditing || (isEditing && !matchingSelectedRole)}
                />
              </Cell>
            )}
          </Row>
        );
      })}
    </>
  );
};

export default RoleList;
